/**
 * CortexCommandCentreV2 — Agentic Operator persona showcase.
 *
 * Auto-cycling walkthrough of 8 Cortex capabilities for AI developers
 * orchestrating agent teams. Demonstrates: cross-session memory, pattern search,
 * root cause shortcuts, anti-pattern prevention, morning briefings,
 * ship gates, anomaly detection, and confidence calibration.
 *
 * Route: /cortex/command-centre
 * Existing /cortex (CortexTerminal) is preserved — this is a new view.
 */
import { CommandCentreBase } from '../shared/CommandCentreBase';
import { SCENARIOS, CYCLE_DURATION_MS } from '../../data/cortex-command-centre-data-v2';

export const CortexCommandCentreV2 = () => (
  <CommandCentreBase
    config={{
      scenarios: SCENARIOS,
      cycleDurationMs: CYCLE_DURATION_MS,
      productName: 'Cortex',
      productLabel: 'Cortex Command Centre',
      heroTitle: 'Intelligence Exoskeleton',
      heroSubtitle: 'Intelligence that compounds across sessions. Watch Cortex work through a real engineering day — from morning briefing to outcome learning.',
      backLabel: '← Kempion',
      backPath: '/',
      terminalLabel: '→ Try the interactive terminal',
    }}
  />
);
